/**
 * Scanned-text router (shared design with the handheld web app).
 *
 *   ORD:<id | display id | OFF-...>   -> an order
 *   VCH:<code>                        -> a voucher
 *   MEM:<number>                      -> a loyalty membership card
 *   https://<site>/?voucher=<CODE>    -> a voucher (the printed voucher QR)
 *   anything else                     -> unknown (never acted on)
 *
 * Pure: no DOM, no network.
 */

const clean = (text) =>
  String(text == null ? '' : text)
    // scanner / terminal noise: control characters and the zero-width ones some readers add
    // eslint-disable-next-line no-control-regex
    .replace(/[\u0000-\u001f\u007f​-‍﻿]/g, '')
    .trim();

export const ORDER_PREFIX = 'ORD:';
export const VOUCHER_PREFIX = 'VCH:';
export const MEMBER_PREFIX = 'MEM:';

/** Does the text start like a prefixed scan (used while a burst is still arriving)? */
export const looksLikeScanPrefix = (text) => /^(ord:|vch:|mem:)/i.test(String(text || ''));

export function parseScan(text) {
  const t = clean(text);
  if (!t) return { type: 'unknown', value: '' };

  let m = t.match(/^ORD:\s*(\S.*)$/i);
  if (m) return { type: 'order', value: m[1].trim() };

  m = t.match(/^VCH:\s*(\S.*)$/i);
  if (m) return { type: 'voucher', value: m[1].trim() };

  m = t.match(/^MEM:\s*(\S.*)$/i);
  if (m) return { type: 'member', value: m[1].trim() };

  if (/^https?:\/\//i.test(t)) {
    let code = null;
    try {
      code = new URL(t).searchParams.get('voucher');
    } catch (e) {
      const q = t.match(/[?&]voucher=([^&#\s]+)/i);
      if (q) {
        try {
          code = decodeURIComponent(q[1]);
        } catch (e2) {
          code = q[1];
        }
      }
    }
    if (code && code.trim()) return { type: 'voucher', value: code.trim() };
  }

  return { type: 'unknown', value: t };
}

/** The text sent to GET /v3/membership/lookup?code= for a parsed member scan. */
export const memberLookupCode = (parsed) => `${MEMBER_PREFIX}${parsed.value}`;

/** The text sent to GET /v3/orders/lookup?code= for a parsed order scan. */
export const orderLookupCode = (parsed) => `${ORDER_PREFIX}${parsed.value}`;
